/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Lifecycle_Impact_CommentsInputs */

const en_lifecycle_impact_comments = /** @type {(inputs: Lifecycle_Impact_CommentsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comments: ${i?.count}`)
};

const de_lifecycle_impact_comments = /** @type {(inputs: Lifecycle_Impact_CommentsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kommentare: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Comments: {count}" |
*
* @param {Lifecycle_Impact_CommentsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_impact_comments = /** @type {((inputs: Lifecycle_Impact_CommentsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Impact_CommentsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_impact_comments(inputs)
	return en_lifecycle_impact_comments(inputs)
});